import addinSettings from "@/services/common/addinSettingsService";
import diagnostics, { DEBUG, INFO, WARNING, ERROR } from "@/services/diagnostics/diagnosticsService";

const log = (level, message, data) => {
    const diagnosticsEnabled = addinSettings.get().diagnosticsEnabled || false;

    if (diagnosticsEnabled) {
        diagnostics.log(level, message, null, null, data);
    }
}

const debug = (message, data = null) => log(DEBUG, message, data);

const info = (message, data = null) => log(INFO, message, data);

const warning = (message, data = null) => log(WARNING, message, data);

const error = (message, data = null) => log(ERROR, message, data);

export {
    debug,
    info,
    warning,
    error
}

export default {
    debug,
    info,
    warning,
    error
}